export default __webpack_public_path__ + "static/media/Traffic.e7ca6658.md";